import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.regexp.split";
var marginRE = /^-?\d*\.?\d+(px|%)$/;
export function parseRootMargin(rootMargin) {
  var marginString = rootMargin ? rootMargin.trim() : '0px';
  var result = marginString.split(/\s+/).map(function (margin) {
    if (!marginRE.test(margin)) {
      throw new Error('rootMargin must be a string literal containing pixels and/or percent values');
    }

    return margin;
  });
  var m0 = result.shift();

  var _result = _slicedToArray(result, 3),
      _result$ = _result[0],
      m1 = _result$ === void 0 ? m0 : _result$,
      _result$2 = _result[1],
      m2 = _result$2 === void 0 ? m0 : _result$2,
      _result$3 = _result[2],
      m3 = _result$3 === void 0 ? m1 : _result$3;

  return "".concat(m0, " ").concat(m1, " ").concat(m2, " ").concat(m3);
}
export function shallowCompare(next, prev) {
  if (Array.isArray(next) && Array.isArray(prev)) {
    if (next.length === prev.length) {
      return next.some(function (_, index) {
        return shallowCompare(next[index], prev[index]);
      });
    }
  }

  return next !== prev;
}
var _Object$prototype = Object.prototype,
    hasOwnProperty = _Object$prototype.hasOwnProperty,
    toString = _Object$prototype.toString;
export { hasOwnProperty, toString };
export function isChildrenWithRef(children) {
  return children && hasOwnProperty.call(children, 'ref');
}